import { Box, Link, Text } from '@chakra-ui/react'
import { FiExternalLink } from 'react-icons/fi'

interface BillContentDetailsProps {
  summary: string | null
  fullTextUrl: string | null
}

/** Slice-3 bill content on a linked bill: LegiScan synopsis + a link out to the authoritative full text.
 *  Renders nothing when the bill carries neither (older links, or a state with no document link). */
export function BillContentDetails({ summary, fullTextUrl }: BillContentDetailsProps) {
  if (!summary && !fullTextUrl) return null
  return (
    <Box mt={1}>
      {!!summary && <Text fontSize="sm" color="fg.muted">{summary}</Text>}
      {!!fullTextUrl && (
        <Link href={fullTextUrl} target="_blank" rel="noopener noreferrer" fontSize="sm" gap={1}>
          Read full text <FiExternalLink aria-hidden />
        </Link>
      )}
    </Box>
  )
}
